import { IonIcon } from '@ionic/react'
import { warningOutline } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import { pushFx } from '~/shared/lib/history'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { Title, Wrapper } from './styled'

type Props = {
  message?: string
  fullScreen?: boolean
}

export function NotFound({ message }: Props) {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <IonIcon
        icon={warningOutline}
        style={{ color: myPalette.orange.main, fontSize: '60px' }}
      />
      <br />

      <Title>{message || t('alert.the page is not found')}</Title>

      <Button variant='textBlue' onClick={() => pushFx('/')}>
        {t('button.go to main page')}
      </Button>
    </Wrapper>
  )
}
